var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHighlightShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 94,
    viewBox: "0 0 86 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.9316 87.28C55.0829 84.9926 63.617 83.8387 71.8956 82.7816C73.6787 82.5599 75.3341 83.7966 75.4615 85.539C75.7162 87.2826 74.4418 88.8771 72.7861 89.0988C64.7622 90.1164 56.4844 91.2053 48.7152 93.4074C47.0595 93.8851 45.2757 92.9018 44.7662 91.2104C44.2568 89.5203 45.2759 87.7589 46.9316 87.28Z",
    fill: "#484EA1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4132 54.8492C45.5317 41.462 60.3058 29.7981 73.1695 16.0518C74.3157 14.768 76.3535 14.6992 77.6272 15.8977C78.9008 17.0974 79.0277 19.1149 77.754 20.3987C64.8904 34.1845 50.1162 45.8866 36.9978 59.3132C35.7242 60.5665 33.6869 60.5843 32.4132 59.3514C31.267 58.1198 31.1396 56.1024 32.4132 54.8492Z",
    fill: "#484EA1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.83167 13.5464C7.44958 21.2086 7.06823 28.8708 6.68615 36.5342C6.68615 38.2893 5.15704 39.6444 3.37396 39.5591C1.59087 39.4725 0.317987 37.9785 0.317986 36.2222C0.700075 28.5473 1.08142 20.8736 1.46351 13.2C1.59087 11.4449 3.11948 10.0987 4.90256 10.1942C6.55828 10.2898 7.95903 11.7927 7.83167 13.5464Z",
    fill: "#484EA1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlightShape);
export default __webpack_public_path__ + "static/media/highlight_shape.c0f468e2320e88caed7d945d646c0dd8.svg";
export { ForwardRef as ReactComponent };